import { ActionTypes } from './action-types.enum';

const initialState = {
  user: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_USER:
      return {
        ...state,
        user: action.payload?.user,
      };
    default:
      return state;
  }
};
